"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoaderRender = void 0;
var React = __importStar(require("react"));
var react_1 = require("react");
var Loader_1 = __importDefault(require("semantic-ui-react/dist/commonjs/elements/Loader"));
var tinycolor2_1 = __importDefault(require("tinycolor2"));
var localization_1 = require("@scuf/localization");
var LoaderRender = /** @class */ (function (_super) {
    __extends(LoaderRender, _super);
    function LoaderRender() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LoaderRender.prototype.render = function () {
        var _a = this.props, className = _a.className, inverted = _a.inverted, minHeight = _a.minHeight, text = _a.text, overlayColor = _a.overlayColor, loading = _a.loading, overlayOpacity = _a.overlayOpacity, children = _a.children, t = _a.t, lng = _a.lng, rest = __rest(_a, ["className", "inverted", "minHeight", "text", "overlayColor", "loading", "overlayOpacity", "children", "t", "lng"]);
        return (React.createElement(React.Fragment, null,
            React.createElement("div", __assign({}, rest, { className: this.genLoaderClasses() }),
                React.createElement(Loader_1.default, { className: "loader", size: "large", inverted: inverted }, text ? text : t('Loading')),
                React.createElement("div", { style: this.genLoaderStyle(), className: "color-overlay" })),
            React.createElement("div", { className: "loader-content", style: { minHeight: minHeight } }, children)));
    };
    LoaderRender.prototype.genLoaderClasses = function () {
        var classString = 'ui loader-wrap';
        if (this.props.className) {
            classString += " " + this.props.className;
        }
        if (this.props.loading) {
            classString += " loading";
        }
        if (this.props.inverted) {
            classString += " inverted";
        }
        return classString;
    };
    LoaderRender.prototype.genLoaderStyle = function () {
        var style = {};
        if (this.props.overlayColor) {
            style.background = tinycolor2_1.default(this.props.overlayColor).toRgbString();
        }
        style.opacity = this.props.overlayOpacity;
        return style;
    };
    return LoaderRender;
}(react_1.Component));
exports.LoaderRender = LoaderRender;
exports.default = localization_1.InjectLocalization(LoaderRender);
